/**
 * vion-icon v1.0.1
 * (c) 2023 yangling
 * @license MIT
 */

import { defineComponent, computed, openBlock, createElementBlock, normalizeStyle, createElementVNode } from 'vue';

var Crop = defineComponent({
  name: "Crop",
  props: {
    color: String,
    size: String
  },
  emits: ["click"],
  setup: function setup(props, ctx) {
    var iconStyle = computed(function () {
      return {
        display: "inline-block",
        fontSize: props.size,
        color: props.color,
        width: "1em",
        height: "1em",
        lineHeight: "1em"
      };
    });
    var click = function click(e) {
      return ctx.emit("click", e);
    };
    return {
      iconStyle: iconStyle,
      click: click
    };
  }
});
Crop.install = function (app) {
  app.component(Crop.name, Crop);
};

var _hoisted_1 = /* @__PURE__ */createElementVNode("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 48 48",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, [/* @__PURE__ */createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M15.1429 8H11.1429V32.2857C11.1429 34.3008 12.633 35.9679 14.5714 36.2452V36.2857H15.134L15.1429 36.2857L30.7714 36.2857V32.2857H15.1429V8ZM9.42857 12.2857H6V16.2857H9.42857V12.2857ZM42.1429 32.2857H38.7143V36.2857H42.1429V32.2857ZM17.2857 12.2857H33C35.0151 12.2857 36.6822 13.7758 36.9595 15.7143H37L37 16.2857L37 40.4643H33V16.2857H17.2857V12.2857Z",
  fill: "currentColor"
})], -1);
var _hoisted_2 = [_hoisted_1];
function render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("i", {
    class: "v-icon",
    onClick: _cache[0] || (_cache[0] = function () {
      return _ctx.click && _ctx.click.apply(_ctx, arguments);
    }),
    style: normalizeStyle(_ctx.iconStyle)
  }, _hoisted_2, 4);
}

Crop.render = render;

export { Crop as default };
